module.exports = __webpack_public_path__ + "img/234x6O.d41d8cd9.svg";